<script>
import axios from "axios";
import router from "@/router";
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import progressContainer from './progressContainer';

export default {
  page: {
    title: "Applicant History",
    meta: [
      {
        name: "Applicant History",
      },
    ],
  },
  components: { /*logoutButton ,*/ Header , Footer, progressContainer },
  data(){
    return{
      title: "Applicant History",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      isShow: false,
      errors:[],
      userData : JSON.parse(localStorage.getItem('web_user')),
      questionForm: {
        submit_application: "",
        driver_license: "",
        driving_violations: "",
        treatment: "",
        arrested: "",
        convicted: "",
        refrain: "",
        hear_about: "",
        user_type_id:""
      },
      backToOverview: false,
      beforeSubmittedApplication:false,
      license:false,
      drivingViolations:false,
      drugPrescription:false,
      involveInAlcohol:false,
      convictedCriminal:false,
      refrainTobacco:false,

      beforeSubmittedText:false,
      drugPrescriptionText:false,
      involveInAlcoholText:false,
      convictedCriminalText:false,
      refrainTobaccoText:false,
      typeSubmit:true,
      illegalDrugUsage:false,
      tobaccoUsage:false
    }
  },
  mounted(){
    this.getQuestions();
    this.getSubmitFormStats();
    this.checkEmptyFields();
  },
  methods: {
    contactInfo() {
      router.push({ name: 'contact-info'})
    },

    skipToReview() {
      router.push({ name: 'review-application'})
    },
    backgroundCheckDetails() {
      router.push({ name: 'background-check'})
    },
    addQuestion() {

      const userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: {Authorization: 'Bearer '+userData.token}
      };
      if (userData.token){
        this.questionForm.user_type_id = userData['user_type_id'];
        axios.post('user/questions', this.questionForm,config)
            .then((res) => {
              if (res.status == 200){
                if (userData.user_type_id === 3){
                  router.push({ name: 'faith'})
                }
                else{
                  router.push({ name: 'faith'})
                }
              }
            })
            .catch((err) => {
              if (err.response) {
                this.isShow = true;
                this.errors = err.response.data.error.message;
              }
            })
      }
    },

    checkEmptyFields(){
      (this.questionForm.submit_application != "") ? this.beforeSubmittedApplication = true : this.beforeSubmittedApplication = false;
      (this.questionForm.treatment != "") ? this.drugPrescription = true : this.drugPrescription = false;
      (this.questionForm.arrested != "") ? this.involveInAlcohol = true : this.involveInAlcohol = false;
      (this.questionForm.convicted != "") ? this.convictedCriminal = true : this.convictedCriminal = false;
      (this.questionForm.refrain != "") ? this.refrainTobacco = true : this.refrainTobacco = false;
      (this.questionForm.driver_license != "") ? this.license = true : this.license = false;
      (this.questionForm.driving_violations != "") ? this.drivingViolations = true : this.drivingViolations = false;

    },

    checkNotEmptyFields(){

      if(this.beforeSubmittedApplication == false){
        this.questionForm.submit_application = "";
      }
      if(this.convictedCriminal == false){
        this.questionForm.convicted = "";
      }
      if(this.drugPrescription == false){
        this.questionForm.treatment = "";
      }
      if(this.involveInAlcohol == false){
        this.questionForm.arrested = "";
      }



      (this.questionForm.submit_application == null && this.beforeSubmittedApplication == true) ? this.beforeSubmittedText = true : this.beforeSubmittedText = false;
      (this.questionForm.treatment == null && this.drugPrescription == true) ? this.drugPrescriptionText = true : this.drugPrescriptionText = false;
      (this.questionForm.arrested == null  && this.involveInAlcohol == true) ? this.involveInAlcoholText = true : this.involveInAlcoholText = false;
      (this.questionForm.convicted == null  && this.convictedCriminal == true) ? this.convictedCriminalText = true : this.convictedCriminalText = false;
      // (this.questionForm.refrain == null  && this.refrainTobacco == true) ? this.refrainTobaccoText = true : this.refrainTobaccoText = false;

      if (this.beforeSubmittedText != true && this.drugPrescriptionText != true && this.involveInAlcoholText != true
          && this.convictedCriminalText != true) {
        this.addQuestion();
      }
    },
    // Getting Current User Forms States
    getSubmitFormStats() {
      let formCompleted = true;
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: { Authorization: 'Bearer ' + userData['token'] },
      };
      if (userData.token) {
        axios
          .get(
            'user/registration/submitted-forms?user_type_id=' +
              userData['user_type_id'],
            config
          )
          .then((res) => {
            // Mentor
            // Mentor
            if( userData['user_type_id'] == 3 ) {
              if (res.data.response.additional_details === false) {
                formCompleted = false;
              }
              if (res.data.response.background === false) {
                formCompleted = false;
              }
              if (res.data.response.faith === false) {
                formCompleted = false;
              }
              if (res.data.response.personal_info === false) {
                formCompleted = false;
              }
              if (res.data.response.question === false) {
                formCompleted = false;
              }
              if (res.data.response.reference === false) {
                formCompleted = false;
              }
            } else {
              if( userData.is_mentor ) {
                // Mentor/Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.background === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
                if (res.data.response.reference === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
              } else {
                // Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
              }
              
            }
            
            if( !formCompleted ) {
              this.backToOverview = false;
            } else {
              this.backToOverview = true;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },

    // Getting Current User Questions
    getQuestions() {
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: {Authorization: 'Bearer '+userData.token}
      };
      if (userData.token){
        axios.get('user/questions/'+userData['id']+'?user_type_id='+userData['user_type_id'],config)
            .then((res) => {
              this.res = res.data.response[0];
                if (res != null){
                  this.questionForm = res.data.response
                  if (this.questionForm.submit_application){
                    this.beforeSubmittedApplication=true;
                  }
                  if (this.questionForm.driver_license){
                    this.license=true;
                  }
                  if (this.questionForm.driving_violations){
                    this.drivingViolations=true;
                  }
                  if (this.questionForm.treatment){
                    this.drugPrescription=true;
                  }
                  if (this.questionForm.convicted){
                    this.convictedCriminal=true;
                    // this.involveInAlcohol=true;                    
                    // this.refrainTobacco=true;
                  }
                  if (this.questionForm.arrested){
                    this.involveInAlcohol=true;
                    // this.convictedCriminal=true;
                  }
                  if (this.questionForm.refrain){
                    this.refrainTobacco=true;
                  }
                }
                else{
                  return true;
                }
            })
            .catch((err) => {
              if (err.response) {
                console.log(err.response.data.error.message);
              }
            })
      }
    },
    fillRefrain(){
      this.questionForm.refrain = "Good";
    },
    removeRefrain(){
      this.questionForm.refrain = "";
    },
    fillviolation(){
      this.questionForm.driving_violations = "Good";
    },
    fillAppBefore(){
      this.questionForm.submit_application = "Good";
    },
    removeAppBefore(){
      this.questionForm.submit_application = "";
    },

removeviolation(){
      this.questionForm.driving_violations = "";
    },
    contactt() {
      router.push({ name: 'contact'})
    },

  },
}
</script>

<template>
  <div>
    <Header></Header>
    <div class="main-body">
      <div id="main-title" class="secondary">
        <div class="container">
          <div class="row mx-0">
            <div class="col-12 col-lg-6 align-self-center">
              <h3 class="title" v-if="userData.is_mentor"> Mentor / Volunteer Details</h3>
              <h3 class="title" v-else>{{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }} Application</h3>
            </div>
            <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
              <p class="need-help">Need Help ? <a @click="contactt" href="javascript:">Contact Us</a> </p>
            </div>
          </div>
        </div>
      </div>
      <div id="create-account">
        <div class="container">
          <div class="row mx-0 justify-content-center">
            <div class="col-12">
              
              <progressContainer
                  :userData="userData"
                  :active="'questions'"
                />

              
            </div>
          </div>
          <form class="custom-form">
            <div class="row mx-0">
              <div class="col-12 mb-5">
                <h3 class="main-title">Applicant History</h3>
              </div>
              <div v-show="isShow" class="alert alert-danger col-12">
                <span class="d-block" v-for="(error,index) in errors" :key="index">- {{error}}</span>
              </div>
            </div>
            <div class="row mx-0">
              <!-- 1 -->
              <div class="col-12 mb-5">
                <label>
                  Have you submitted an application to mentor or volunteer at MnTC before?*
                  <!-- Have you submitted an application here before?* -->
                  </label>

                <input :value="true" @click="fillAppBefore" v-model="beforeSubmittedApplication" class="form-check-input" type="radio" id="beforeSubmittedApplication" />
                <label class="form-check-label" for="beforeSubmittedApplication">Yes</label>

                <input :value="false" @click="removeAppBefore" v-model="beforeSubmittedApplication" class="me-2 form-check-input" type="radio" id="beforeSubmittedApplicationNo" />
                <label class="form-check-label" for="beforeSubmittedApplicationNo">No</label>

                <!-- <input v-if="beforeSubmittedApplication"  v-model="questionForm.submit_application" type="text" class="mt-2 form-control" name="submit_application"/>
                <span class="d-block text-center text-danger font-size-16 mt-2" v-if="beforeSubmittedText">*Please fill this</span> -->
              </div>
              <!-- 1 -->
              <div class="col-12 mb-5">
                <label> Have you been convicted of a criminal offense (not including traffic violations)?*</label>
                <input :value="true"  v-model="convictedCriminal" class="form-check-input" type="radio" id="convictedCriminal" />
                <label class="form-check-label" for="convictedCriminal">Yes</label>

                <input :value="false" v-model="convictedCriminal" class="me-2 form-check-input" type="radio" id="convictedCriminalNo" />
                <label class="form-check-label" for="convictedCriminalNo">No</label>

                <input v-if="convictedCriminal" v-model="questionForm.convicted" type="text" name="convicted" class="mt-2 form-control" />
                <span class="d-inline-block text-muted mt-2 font-size-14" v-if="convictedCriminal">(Please list offense(s) and year(s) of conviction.)</span>
                <span class="d-block text-center text-danger font-size-16 mt-2" v-if="convictedCriminalText">*Please fill this</span>
              </div>
              <!-- 1 -->
              <div class="col-12 mb-5">
                <label>Have you sought treatment for substance use disorders?*</label>
                <input :value="true" v-model="drugPrescription" class="form-check-input" type="radio" id="drugPrescription" />
                <label class="form-check-label" for="drugPrescription">Yes</label>

                <input :value="false" v-model="drugPrescription" class="me-2 form-check-input" type="radio" id="drugPrescriptionNo" />
                <label class="form-check-label" for="drugPrescriptionNo">No</label>

                <input v-if="drugPrescription" v-model="questionForm.treatment" type="text" name="treatment" class="mt-2 form-control" />

                <span class="d-inline-block text-muted mt-2 font-size-14" v-if="drugPrescription">(Briefly describe treatment program and dates.)</span>
                <span class="d-block text-center text-danger font-size-16 mt-2" v-if="drugPrescriptionText">*Please fill this</span>
              </div>              
              <!-- 1 -->
              <div class="col-12 mb-5">
                <label>Have you been arrested for an offense involving substance use disorders?*</label>
                <input :value="true" v-model="involveInAlcohol" class="form-check-input" type="radio" id="involveInAlcohol" />
                <label class="form-check-label ms-1" for="involveInAlcohol">Yes</label>

                <input :value="false" v-model="involveInAlcohol" class="me-2 form-check-input" type="radio" id="involveInAlcoholNo" />
                <label class="form-check-label" for="involveInAlcoholNo">No</label>

                <input v-if="involveInAlcohol" v-model="questionForm.arrested" type="text" name="arrested" class="mt-2 form-control" />
                <span class="d-inline-block text-muted mt-2 font-size-14" v-if="involveInAlcohol">(Please list offense(s) and year(s) of conviction.)</span>
                <span class="d-block text-center text-danger font-size-16 mt-2" v-if="involveInAlcoholText">*Please fill this</span>

              </div>
              <!-- 1 -->
               <div class="col-12 mb-5">
                <label> Have you used illegal drugs, abused prescription drugs, or abused alcohol within the past two years?*</label>
                <input :value="true" v-model="drivingViolations" @click="fillviolation" class="form-check-input" type="radio" id="drivingViolations" />
                <label class="form-check-label" for="drivingViolations">Yes</label>

                <input :value="false" v-model="drivingViolations" @click="removeviolation" class="me-2 form-check-input" type="radio" id="drivingViolationsNo" />
                <label class="form-check-label" for="drivingViolationsNo">No</label>
              <br>
              <span class="d-inline-block text-muted mt-2 font-size-14" v-if="drivingViolations"> {{userData['user_type_id'] === 4?'Volunteers':'Mentor'}}  must have two (2) years of freedom from any illegal drug use, prescription drug abuse, or alcohol abuse.</span>
              </div>


       <div class="col-12 mb-5">
                <label>Do you use tobacco products (cigarettes, e-cigarettes/vapes, chewing tobacco, etc.) or live with someone who does?*</label>
                <input :value="true" v-model="refrainTobacco" @click="fillRefrain" class="form-check-input" type="radio" id="refrainTobacco" />
                <label class="form-check-label" for="refrainTobacco">Yes</label>

                <input :value="false"  v-model="refrainTobacco" @click="removeRefrain" class="me-2 form-check-input" type="radio" id="refrainTobaccoNo" />
                <label class="form-check-label" for="refrainTobaccoNo">No</label>

                <!-- <input v-if="refrainTobacco" v-model="questionForm.refrain" type="hidden" class="mt-2 form-control" name="refrain" /> -->
                <br>
                <span class="d-inline-block text-muted mt-2 font-size-14" v-if="refrainTobacco"> {{ userData['user_type_id'] === 3 ? 'Mentors' : 'Volunteers' }}  must be free of tobacco odors while spending time with clients.</span>
                <!-- <span class="d-block text-center text-danger font-size-16 mt-2" v-if="refrainTobaccoText">*Please fill this</span> -->
              </div>          


              <!-- <div class="col-12 mb-5">
                <label>Do you have a valid driver's license?</label>
                <input :value="true" v-model="license" class="form-check-input" type="radio" id="license" />
                <label class="form-check-label" for="license">Yes</label>

                <input :value="false" v-model="license" class="me-2 form-check-input" type="radio" id="licenseNo" />
                <label class="form-check-label" for="licenseNo">No</label>

                <input v-if="license" v-model="questionForm.driver_license" type="text" name="driver_license" class="mt-2 form-control" />
              </div> -->




              <!-- <div class="col-12 mb-5">
                <label>When and how did you first hear about Mn Adult & Teen Challenge?</label>
                <input v-model="questionForm.hear_about" type="text" name="hear_about" class="mt-2 form-control" />
              </div> -->
            </div>
            <div class="row mx-0">
                <div class="mb-2 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-end align-items-stretch align-items-md-start" v-if="backToOverview">
                  <b-button type="button" @click="skipToReview" variant="custom">
                    <i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
                    Skip To Review
                  </b-button>
                </div>
                <!-- <div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-if="userData.is_mentor">
                  <b-button type="button" @click="backgroundCheckDetails" variant="custom">Background Check Details <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
                  <b-button type="button" @click="contactInfo" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Contact Details</b-button>
                </div> -->
                <div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start">
                  <b-button v-if="userData['user_type_id'] === 4 && !userData.is_mentor" type="button" @click="contactInfo" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Contact Details</b-button>
                  <b-button v-else type="button" @click="backgroundCheckDetails" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Background Check Information</b-button>
                  <b-button type="button" @click="checkNotEmptyFields" variant="custom"> Faith Journey <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
                  <!-- <b-button type="button" v-else-if="userData['user_type_id'] === 3" @click="checkNotEmptyFields" variant="custom">Background Check Details <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button> -->
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
